var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C10.4241 0 8.86371 0.310389 7.4078 0.913446C5.95189 1.5165 4.62902 2.40042 3.51472 3.51472C1.26428 5.76515 0 8.8174 0 12C0 17.304 3.444 21.804 8.208 23.4C8.808 23.496 9 23.124 9 22.8V20.772C5.676 21.492 4.968 19.164 4.968 19.164C4.416 17.772 3.636 17.4 3.636 17.4C2.544 16.656 3.72 16.68 3.72 16.68C4.92 16.764 5.556 17.916 5.556 17.916C6.6 19.74 8.364 19.2 9.048 18.912C9.156 18.132 9.468 17.604 9.804 17.304C7.14 17.004 4.344 15.972 4.344 11.4C4.344 10.068 4.8 9 5.58 8.148C5.46 7.848 5.04 6.6 5.7 4.98C5.7 4.98 6.708 4.656 9 6.204C9.948 5.94 10.98 5.808 12 5.808C13.02 5.808 14.052 5.94 15 6.204C17.292 4.656 18.3 4.98 18.3 4.98C18.96 6.6 18.54 7.848 18.42 8.148C19.2 9 19.656 10.068 19.656 11.4C19.656 15.984 16.848 16.992 14.172 17.292C14.604 17.664 15 18.396 15 19.512V22.8C15 23.124 15.192 23.508 15.804 23.4C20.568 21.792 24 17.304 24 12C24 10.4241 23.6896 8.8637 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40042 18.0481 1.5165 16.5922 0.913446C15.1363 0.310389 13.5759 0 12 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.019403f804119490fd6fd2f8658423dd.svg";
export { ForwardRef as ReactComponent };